// import React from 'react';
// import { useState, useEffect } from 'react';

//import io from 'socket.io-client';
//const socket = io('http://localhost:5001');


export function receiveServerMessage(socket, callback) {
  socket.on('FE-getdata-from-server', ({ participantList, dataObj }) => {
    //console.log(dataObj,'-----data120-----', participantList);
    callback({ participantList, dataObj });
  });

}
export function oneToOneMessage(socket, callback) {
  socket.on('FE-getmessage-from-oneuser', (data) => { //{acsRoomId,senderUserId, socketId, type,data}
    //console.log('-----data one message1-----', data);
    callback(data); //acsRoomId,senderUserId, socketId, type,
  });

}
export function updateUiOnAcceptCall(socket, callback) {
  socket.on('FE-accept-user', ({ participantList, dataObj, value, type, userIdFromServer }) => {
    //console.log(dataObj,'-----data120-----', participantList);
    callback({ participantList, dataObj, value, type, userIdFromServer });
  });

}

export function userFullyJoined(socket, callback) {
  socket.on('FE-user-fully-joined', ({ participantList, dataObj, userId, timestamp }) => {
    console.log('FE-user-fully-joined event received:', userId, dataObj);
    callback({ participantList, dataObj, userId, timestamp });
  });
}
export function updateStatusOnUi(socket, callback) {
  socket.on('FE-update-status', ({ acsRoomId, senderUserId, socketId, data, type, typeValue, adminId, message }) => {
    callback({ acsRoomId, senderUserId, socketId, data, type, typeValue, adminId, message });
  });

  socket.on('FE-error-user-exist', (err) => {
    console.log('--err from socket server- ', err);
  });
}
export function onloadCheckUserAlreadyJoined(socket, callback) {
  socket.on('FE-user-join', (data) => {
    console.log('---User joined- ', data);
    callback(data);
  });
}

// DisplayParticipantComponent socket event handlers
export function hideLobbyPopup(socket, callback) {
  socket.on('FE-hide-lobby-popup', ({ userId }) => {
    console.log("🔕 Hide lobby popup for userId:", userId);
    callback({ userId });
  });
}

export function syncLobby(socket, callback) {
  socket.on('FE-sync-lobby', ({ acsRoomId, userId, action, timestamp }) => {
    console.log(`🔄 Lobby sync: User ${userId} was ${action} at ${timestamp}`);
    callback({ acsRoomId, userId, action, timestamp });
  });
}

export function bulkLobbyUpdate(socket, callback) {
  socket.on('FE-bulk-lobby-update', ({ acsRoomId, action, userIds, adminUserId }) => {
    console.log(`🔄 Bulk lobby update: ${userIds.length} users were ${action} by admin ${adminUserId}`);
    callback({ acsRoomId, action, userIds, adminUserId });
  });
}

export function allowAllResponse(socket, callback) {
  socket.on('FE-allow-all-response', ({ success, message, userIds, adminUserId }) => {
    console.log(`🎯 Allow All response: ${success ? 'SUCCESS' : 'FAILED'} - ${message}`);
    callback({ success, message, userIds, adminUserId });
  });
}

export function bulkParticipantUpdate(socket, callback) {
  socket.on('FE-bulk-participant-update', ({ acsRoomId, action, userIds, adminUserId }) => {
    console.log(`🔄 Bulk participant update: ${userIds.length} users were ${action} by admin ${adminUserId}`);
    console.log(`🔄 Action type: ${action}, User IDs:`, userIds);
    callback({ acsRoomId, action, userIds, adminUserId });
  });
}

export function bulkParticipantError(socket, callback) {
  socket.on('FE-bulk-participant-error', ({ acsRoomId, action, error, failedUserIds, adminUserId }) => {
    console.error(`❌ Bulk participant error: ${action} failed - ${error}`);
    callback({ acsRoomId, action, error, failedUserIds, adminUserId });
  });
}